/**
 * @ignore
 * Created by daletan on 8/24/16.
 */

'use strict';

const $ = require('dibs-jquery-shim');
const React = require('react');
const PropTypes = require('prop-types');
const Relay = require('react-relay/classic');
const SV = require('server-vars');
const Page = require('./index.es');

const { getEnvironment } = require('../global/relayEnvironmnentProvider.es').default;

const { getUserId, cookieJarConstants } = require('dibs-cookie-jar');
const { MASQUERADE_BUYER } = cookieJarConstants;

const { createStore, combineReducers } = require('redux');
const { Provider } = require('react-redux');
const { reducers: shippingQuoteModal } = require('dibs-request-shipping-modal');

// Redux store is for shipping quote request modal, which needs to maintain its state through forceUpdateFromUserLogin
// Todo: Is store still needed now that forceUpdateFromUserLogin isn't necessary?
const reduxStore = createStore(combineReducers({ shippingQuoteModal }));

/**
 * Needed for dibs-portfolio-heart and dibs-portfolio-folder
 * relay requests
 */
function getSelectedItemIds() {
    const itemId = SV.get('data.pk');
    // related items
    // TODO: GROWTH-2844 should be removed after refactor
    const moreFromSellerItems = SV.get('carousel.items') || [];
    const mayAlsoLikeItems = SV.get('recommendedCarousel.items') || [];

    return [
        itemId,
        ...mayAlsoLikeItems.map(({ id }) => id),
        ...moreFromSellerItems.map(({ id }) => id),
    ];
}

class NewPdpRoot extends React.Component {
    constructor(props) {
        super(props);

        // relay props
        this.state = this.getRelayVariables();
    }

    componentDidMount() {
        $.subscribe('login:change', () => {
            this.setState(this.getRelayVariables());
        });
    }

    getRelayVariables() {
        const userId = getUserId(document.cookie, MASQUERADE_BUYER);
        const hasUserId = !!userId;

        return {
            hasUserId,
            loadPortfolioData: hasUserId,
            // related items
            // TODO: GROWTH-2844 should be removed after refactor
            selectedItemIds: getSelectedItemIds(),
            shouldFillInFolder: hasUserId,
            userId,
            userIds: hasUserId ? [userId] : [],
        };
    }

    render() {
        const props = this.props;
        const relayVariables = this.state;
        const queryConfig = {
            name: 'NewPdpContainer',
            queries: {
                viewer: (Component, params) => Relay.QL`
                    query {
                        viewer {
                            ${Component.getFragment('viewer', params)}
                        }
                    }
            `,
            },
            params: relayVariables,
        };

        return (
            <Provider store={reduxStore}>
                <Relay.Renderer
                    Container={Page}
                    environment={getEnvironment()}
                    queryConfig={queryConfig}
                    render={({ props: queryProps }) => {
                        //eslint-disable-line react/display-name, react/prop-types
                        if (queryProps) {
                            return (
                                <Page
                                    {...queryProps}
                                    {...props}
                                    {...relayVariables}
                                    context={props.context}
                                />
                            );
                        }
                        // return with null viewer so the entire page does not flash
                        return (
                            <Page
                                viewer={null}
                                {...props}
                                {...relayVariables}
                                context={props.context}
                            />
                        );
                    }}
                />
            </Provider>
        );
    }
}

NewPdpRoot.propTypes = {
    context: PropTypes.object.isRequired,
};

module.exports = NewPdpRoot;



// WEBPACK FOOTER //
// ./assets/js/newPdp/NewPdpRoot.jsx